var map = {
	"./adityabhan.jpg": 2311,
	"./chaitanya.jpg": 3882,
	"./nakul.jpg": 2090,
	"./nishtha.jpg": 5247,
	"./nittin.jpg": 2230,
	"./ritesh.jpg": 1953,
	"./shrejal.jpg": 4986,
	"./unknown.jpg": 9577,
	"./vivek.jpg": 7900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;